// 遊戲常數定義
export const GAME_CONFIG = {
  AGENTS_COUNT: 66, // 稍微增加數量增加混亂感
  SPEED: 1.8,
  RADIUS_BASE_DIVISOR: 28, 
  MIN_RADIUS: 14,
  COLLISION_DIST_RATIO: 1.8,
  VICTORY_DURATION: 3000,
};

export const TYPES = {
  ROCK: 0,
  SCISSORS: 1,
  PAPER: 2,
};

export const WIN_MATRIX = [
  [false, true, false], 
  [false, false, true], 
  [true, false, false], 
];

export const ASSETS = {
  COLORS: ['#FF9F43', '#FF4757', '#2ED573'], // 飽和度更高的顏色
  EMOJIS: ['✊🏼', '✂️', '🖐'],
  LABELS: ['石頭', '剪刀', '布'],
  CLASS_NAMES: ['emoji-rock', 'emoji-scissors', 'emoji-paper']
};